import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: theme.spacing(1, 3),
    borderRadius: theme.spacing(8),
    color: theme.colorPalette.green_100,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.33,
    whiteSpace: 'nowrap'
  },
  orange: {
    backgroundColor: theme.colorPalette.orange_50_op_25
  },
  blue: {
    backgroundColor: theme.colorPalette.blue_50_op_25
  },
  yellow: {
    backgroundColor: theme.colorPalette.yellow_50_op_25
  },
  green: {
    backgroundColor: theme.colorPalette.green_50_op_25
  },
  red: {
    backgroundColor: theme.colorPalette.red_50_op_25
  },
  grey: {
    backgroundColor: theme.colorPalette.beige_75_op_25
  }
});

export default makeStyles(styles);
